// extracted by mini-css-extract-plugin
export default {"logo":"Login_logo__r8GBi","loginForm":"Login_loginForm__ZDHzl","france":"Login_france__fuNDE"};